import "../../css/fonts.css";
import "../../css/container.css";
import "../../css/misc.css";

import { ContainerNoBg } from "../../components/container.no.bg";
import { useIsMobile } from "../../hooks/is.mobile";
import mailIcon from "../../assets/icons/mail.png";

export const Contact: React.FC<any> = () => {
  const isMobile = useIsMobile();
  return (
    <div>
      <ContainerNoBg>
        <div
          style={{
            paddingLeft: isMobile ? "0" : "4.5vw",
            paddingTop: isMobile ? "35vw" : "10vw",
            fontSize: isMobile ? "10vw" : "3.5vw",
          }}
          className={"title-text-font" + " " + "text-align"}
        >
          CONTACT US
        </div>

        <div
          style={{
            paddingTop: isMobile ? "12vw" : "3vw",
            paddingLeft: "4.5vw",
            fontSize: isMobile ? "4vw" : "2vw",
          }}
        >
          Contact us — we’re probably fixing a bug, crying, or both. But we’ll
          reply soon!
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            paddingTop: isMobile ? "12vw" : "3vw",
          }}
        >
          <div
            style={{
              paddingLeft: "4.5vw",
              display: "grid",
              gridTemplateColumns: "0.1fr 5fr",
            }}
          >
            <img
              src={mailIcon}
              alt="Logo"
              style={{
                height: isMobile ? "4vw" : "2vw",
                alignSelf: "center",
              }}
            />
            <div
              style={{
                paddingLeft: "1.5vw",
                fontSize: isMobile ? "4vw" : "2vw",
              }}
            >
              info@vh-interactive.hr
              {/* vertex.horizons.interactive@gmail.com */}
            </div>
          </div>
        </div>
      </ContainerNoBg>
    </div>
  );
};
